var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMytrips(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 25
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-mytrips_svg__a",
    x1: "89.052%",
    x2: "2.642%",
    y1: "23.625%",
    y2: "73.969%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF684A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-mytrips_svg__b",
    x1: "73.332%",
    x2: "21.706%",
    y1: "0%",
    y2: "95.439%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9500"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1.275 .95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#3B385E",
    strokeWidth: 1.275,
    d: "M7.518 12.208h1.79c.433 0 .784.352.784.785v1.648h0-3.358v-1.648c0-.433.352-.785.785-.785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-mytrips_svg__a)",
    stroke: "#4C493D",
    strokeWidth: 0.898,
    d: "M1.02 2.7h7.599c.563 0 1.02.457 1.02 1.02v4.96a1.02 1.02 0 01-1.02 1.02H1.02A1.02 1.02 0 010 8.68V3.72C0 3.157.457 2.7 1.02 2.7z",
    transform: "translate(3.604 11.396)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4C493D",
    strokeWidth: 1.275,
    d: "M6.757.935H4.904a.931.931 0 00-.932.932v5.996h3.717V1.867a.932.932 0 00-.932-.932z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.591,
    height: 14.996,
    x: 0.068,
    y: 6.957,
    fill: "url(#ic-mytrips_svg__b)",
    stroke: "#4C493D",
    strokeWidth: 0.898,
    rx: 1.569
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4C493D",
    strokeLinecap: "round",
    strokeWidth: 1.275,
    d: "M3.74 3.385V1.211c0-.217.176-.392.392-.392h3.381c.217 0 .393.175.393.392V3.4h0"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#4C493D",
    strokeLinecap: "round",
    strokeWidth: 1.275
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.226 10.105v8.708m3.071-8.708v8.708"
  })))));
}
export default SvgIcMytrips;